import { useCallback } from 'react';
import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { ExtendedAppointment } from '@frontend/schedule-helpers';
import { useScheduleAppointmentInfoPanelShallowStore } from '../../../../../../stores/schedule-appointment-info-panel.store';
import { useScheduleActionsContext } from '../../ScheduleActionsContext';
import { ScheduleActionsProvider } from '../../ScheduleActionsProvider';
import { useScheduleRequestModalContextValue } from '../hooks/use-schedule-request-modal-context-value';
import { ScheduleRequestPanel } from '../ScheduleRequestModal/ScheduleRequestWrappers/ScheduleRequestPanel';
import { ScheduleRequestFormManager } from './ScheduleRequestFormManager';

const ScheduleRequestDetails = () => {
  const {
    selectedRequest,
    setSelectedRequest: setSelectedRequestFromStore,
    resetSelectedRequest,
  } = useScheduleAppointmentInfoPanelShallowStore('selectedRequest', 'setSelectedRequest', 'resetSelectedRequest');

  const setSelectedRequest = useCallback(
    (request: ScheduleRequest | null) => {
      if (request === null) {
        resetSelectedRequest();
      } else {
        setSelectedRequestFromStore(request as ExtendedAppointment, true);
      }
    },
    [setSelectedRequestFromStore, resetSelectedRequest]
  );

  const { scheduleRequestModalContextValue } = useScheduleRequestModalContextValue({
    refetchScheduleRequestList: () => {},
    selectedRequest: selectedRequest as ScheduleRequest,
    setSelectedRequest: setSelectedRequest as React.Dispatch<React.SetStateAction<ScheduleRequest | null>>,
  });
  const scheduleActionsContextValue = useScheduleActionsContext();

  scheduleRequestModalContextValue.scheduleRequestModalProps.modalProps.show = !!selectedRequest;

  return selectedRequest ? (
    <ScheduleRequestFormManager
      wrapper={ScheduleRequestPanel}
      scheduleRequestModalContextValue={scheduleRequestModalContextValue}
      selectedScheduleRequest={selectedRequest}
      scheduleActionsContextValue={scheduleActionsContextValue}
    />
  ) : null;
};

export const ScheduleRequestDetailsPanel = () => {
  return (
    <ScheduleActionsProvider>
      <ScheduleRequestDetails />
    </ScheduleActionsProvider>
  );
};
